module.exports = __webpack_public_path__ + "img/W-P45.35153693.jpg";